var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTg = function SvgTg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.375 11.135q8.054-3.508 10.74-4.626c5.114-2.127 6.177-2.497 6.87-2.509.152-.003.493.035.713.214.186.151.238.356.262.499s.055.47.031.725c-.277 2.912-1.476 9.979-2.086 13.24-.259 1.38-.767 1.843-1.259 1.888-1.07.099-1.881-.706-2.917-1.385-1.621-1.063-2.537-1.724-4.11-2.761-1.818-1.198-.64-1.857.396-2.933.272-.282 4.984-4.568 5.075-4.957.011-.048.022-.23-.086-.325-.108-.096-.266-.063-.381-.037q-.244.055-7.768 5.134-1.102.757-1.997.738c-.658-.014-1.923-.372-2.863-.677-1.153-.375-2.07-.574-1.99-1.21q.062-.498 1.37-1.018",
    clipRule: "evenodd"
  })));
};
export default SvgTg;